import { Country } from '@ps/core-models';

import { Option } from '@sapphire/result';

import { parseSurveyLocalization } from '../../mappers/survey-localization';

export function localeLabel(
  localization: string,
  countries: readonly Country[],
): string {
  const { countryCode, languageShortCode } =
    parseSurveyLocalization(localization);
  const country = Option.from(
    countries.find((candidate) => candidate.shortCode === countryCode),
  );

  const countryName = country.mapOr(countryCode, ({ name }) => name);
  const languageName = country
    .map(({ language }) => language)
    .andThen((languages) =>
      Option.from(
        languages.find(
          (candidate) =>
            candidate.translateCode === languageShortCode ||
            candidate.shortCode === languageShortCode,
        ),
      ),
    )
    .mapOr(languageShortCode, ({ name }) => name);

  return `${countryName}-${languageName}`;
}
